export default {
  Title: 'Care Approach',
  CareStyle: 'Care Style',
  HowTheyHandleSituations: 'How They Handle Situations',
  PersonalityDimensions: {
    DecisionStyle: 'Decision & Judgment',
    CareDrive: 'Care Motivation & Initiative',
    Reliability: 'If you notice a sudden change in the client’s condition:',
  },
};
